import httpHelper from "@/helpers/httpHelper";
// action types 
export const GET_DETAILS_IDENTIFIER = "getIdentifierDetails";
export const PAY_PURCENT = "payPurcent";
// mutation types
export const SET_DETAILS_IDENTIFIER = "setIdentifierDetails";
// export const SET_INQUIRY_SHEBA = "setInquirySheba";


export default {
    state: {
        detailsIdentifier: {},
        // status: '',
        // dataInquiry: {}
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedDetailsIdentifier(state) {
            return state.detailsIdentifier;
        },
        // loadedInquiry(state) {
        //     return state.dataInquiry;
        // }

    },
    actions: {
        /**
         * Set the inquirySheba Status 
         * @param state
         * @param payload
         */
         [PAY_PURCENT](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .postData('purcents',payload)
                    .then((response) => {
                        // context.commit(SET_DETAILS_IDENTIFIER, response.result);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => {});
            });
        },
        /**
         * Set the inquirySheba Status 
         * @param state
         * @param payload
         */
        [GET_DETAILS_IDENTIFIER](context, payload) {
            
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(`${payload.api}/${payload.id}`)
                    .then((response) => {
                        context.commit(SET_DETAILS_IDENTIFIER, response.result);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => {});
            });
        },
    },
    mutations: {
        // [SET_DETAILS_SHARING](state, payload) {
        //     state.detailsSharing = [...state.detailsSharing, payload];
        // },
        [SET_DETAILS_IDENTIFIER](state, payload) {
            state.detailsIdentifier = payload;
        },
        // [SET_INQUIRY_SHEBA](state, payload) {
        //     state.dataInquiry = payload;
        // }
    }
};